import { render } from "./CustomHTML.vue?vue&type=template&id=ca570204&scoped=true"
import script from "./CustomHTML.vue?vue&type=script&lang=ts"
export * from "./CustomHTML.vue?vue&type=script&lang=ts"

import "./CustomHTML.vue?vue&type=style&index=0&id=ca570204&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca570204"

export default script